













import Vue from 'vue'

export default Vue.extend({
  name: 'Download',
  props: {
    reports: Array,
    entity: String,
    reportsTotals: Object
  },
  computed: {
    canDownloadReports (): boolean {
      return this.reports?.length !== 0 || false
    }
  },
  methods: {
    downloadReports (): void {
      const reportsWithTotals = [...this.reports]
      reportsWithTotals.push({
        id: 'totals',
        trip_started_at: this.t({ s: 'total', component: 'general'}),
        start_address: '',
        trip_ended_at: '',
        end_address: '',
        duration: '',
        distance: this.reportsTotals.distance,
        average_speed: this.reportsTotals.averageSpeed
      })
      this.downloadCSV({
        filename: `${this.entity}.csv`,
        data: reportsWithTotals.map(this.parseReport)
      })
    },
    parseReport: ({ id, ...r }: Record<string, string | number>) => r
  }
})
